import * as H from 'history';

export const routeUtils = {
  pushWithQueryParams: (history: H.History, pathname: string) => {
    history.push({ pathname, search: history.location.search });
  },
};
